var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof mfe_reports_analytics !== "undefined") return resolve();
	__webpack_require__.l("https://static.blinknetwork.eu/mf_analytics_reports/_next/static/chunks/remoteEntry.js", function(event) {
		if(typeof mfe_reports_analytics !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "mfe_reports_analytics");
}).then(function() { return mfe_reports_analytics; });